import messageEditComponent from './message.edit.component';

let messageEditModule = angular.module('messageedit', [
  ])

  .component('messageedit', messageEditComponent)

  .name;

export default messageEditModule;



// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/message/edit/index.js